import { Box, Flex, IconButton, Stack, Text } from "@chakra-ui/react";
import { QuestionOutlineIcon } from "@chakra-ui/icons";
import Pluralize from "pluralize";
import React from "react";
import PriceDisplay from "./payments/PriceDisplay";
import { observer } from "mobx-react-lite";
import { ILessonPaymentStore } from "../stores/types";

type Props = {
  billingInfo: ILessonPaymentStore;
  showBreakdown: boolean;
  lostRequest?: any;
  lessonInfo: { lessonDuration: number };
  [key: string]: any;
};

const EarningSummary = ({
  billingInfo,
  showBreakdown,
  lostRequest,
  lessonInfo,
  ...rest
}: Props) => {
  const lessonCyle =
    lessonInfo.lessonDuration === 4
      ? "/ month"
      : `/ ${Pluralize("wk", lessonInfo.lessonDuration, true)}`;

  const finalTakeHomePay =
    billingInfo.tutorEarnings - billingInfo.firstBookingDiscount;

  return (
    <Box
      bg={["gold.100", "white"]}
      py={[2, 0]}
      width={["100%", "30%"]}
      whiteSpace="nowrap"
      textAlign="center"
      px={[5, 6]}
      {...rest}
    >
      <Stack
        spacing={0}
        align={["center", "normal"]}
        justifyContent={["center", "normal"]}
        isInline
      >
        <Flex
          direction={["row", "column"]}
          align={["center", "normal"]}
          ml={[0, "auto"]}
        >
          <Stack isInline spacing={[1, 2]} align="center">
            <PriceDisplay
              fontSize={["lg", "xl"]}
              fontWeight="bold"
              price={finalTakeHomePay}
              currency={billingInfo.currency}
              priceIsFetched={billingInfo.priceIsFetched}
            />
            <Text
              mt={1}
              opacity={0.7}
              fontWeight={["normal", "bold"]}
              fontSize={["sm", "xs"]}
            >
              {lessonCyle}
            </Text>
          </Stack>
          <Box boxSize={["4px", "0"]} />
          {billingInfo.transportFare > 0 && (
            <Text mt={1} opacity={0.7} fontSize="sm">
              + transport stipend
            </Text>
          )}
        </Flex>
        {/* {showBreakdown && !lostRequest && (
          <IconButton
            aria-label="help"
            display={["none", "flex"]}
            mt={1}
            alignSelf="flex-start"
            icon={<QuestionOutlineIcon />}
            colorScheme="blue"
            variant="link"
          />
        )} */}
      </Stack>
      {showBreakdown && !lostRequest && (
        <Text
          opacity={0.7}
          mt="2px"
          color="blue.500"
          display={["block", "none"]}
          fontSize="xs"
        >
          See breakdown
        </Text>
      )}
    </Box>
  );
};

export default observer(EarningSummary);
